// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"b3a215ce","640":"bd5fce03","858":"08cc2326"}[chunkId] + ".chunk.js";
};